export default {
	name: '',
	data() {
		return {}
	},
	methods: {
		randomWord(randomFlag, min, max) {
			var str = "",
				range = min,
				arr = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h',
					'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z', 'A',
					'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T',
					'U', 'V', 'W', 'X', 'Y', 'Z'
				];

			// 随机产生
			if (randomFlag) {
				range = Math.round(Math.random() * (max - min)) + min;
			}
			for (var i = 0; i < range; i++) {
				pos = Math.round(Math.random() * (arr.length - 1));
				str += arr[pos];
			}
			return str;
		},
		getTimestamp() {
			return new Date().getTime();
		},
		format(inputTime) {
			var date = new Date(Number(inputTime));
			// console.log(date);
			var y = date.getFullYear();
			var m = date.getMonth() + 1;
			m = (m < 10 ? ('0' + m) : m);
			var d = date.getDate();
			d = (d < 10 ? ('0' + d) : d);
			var h = date.getHours();
			h = (h < 10 ? ('0' + h) : h);
			var minute = date.getMinutes();
			var second = date.getSeconds();
			minute = (minute < 10 ? ('0' + minute) : minute);
			second = (second < 10 ? ('0' + second) : second);
			return y + '-' + m + '-' + d + ' ' + h + ':' + minute + ':' + second;
		},
		openLink(url, isNewTab) {
			var aTag = isNewTab ? '_blank' : '_self';
			var ele = document.createElement("a");
			ele.target = aTag;
			ele.href = url;
			document.body.appendChild(ele);
			ele.click();
			document.body.removeChild(ele);
		},
		setCookie(cname, cvalue, exdays) {
			var d = new Date();
			d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
			var expires = "expires=" + d.toGMTString();
			document.cookie = cname + "=" + cvalue + "; " + expires;
		},
		removeCookie(name) {
			var exp = new Date();
			exp.setTime(exp.getTime() - 1);
			var cval = this.getCookie(name);
			if (cval != null)
				document.cookie = name + "=" + cval + ";expires=" + exp.toGMTString();
		},
		getCookie(cname) {
			var name = cname + "=";
			var ca = document.cookie.split(';');
			for (var i = 0; i < ca.length; i++) {
				var c = ca[i].trim();
				if (c.indexOf(name) == 0) return c.substring(name.length, c.length);
			}
			return "";
		}
	}

}



// WEBPACK FOOTER //
// ./src/mixins/common.js